import { selectProblems } from './select-problems';
import { whereProblems } from './where-problems';
import { joinProblems } from './join-problems';
import { groupbyProblems } from './groupby-problems';
import { subqueryProblems } from './subquery-problems';
import { dmlProblems } from './dml-problems';

export { selectProblems, whereProblems, joinProblems, groupbyProblems, subqueryProblems, dmlProblems };
export type { ProblemDefinition, QueryResult, Difficulty, ProblemTopic, ComparisonMode } from './types';

export const allProblems = [...selectProblems, ...whereProblems, ...joinProblems, ...groupbyProblems, ...subqueryProblems, ...dmlProblems];
